import type { TextFieldProps } from "@mui/material";
import type { ReactElement } from "react";
import React from "react";
import type { ControllerProps } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";

type ControlledInputProps = {
  label: string;
  children: ReactElement;
} & Omit<ControllerProps, "render">;

const ControlledInput: React.FC<ControlledInputProps> = ({
  name,
  label,
  children,
  defaultValue,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) =>
        React.cloneElement(children, {
          ...field,
          ...props,
          label,
          error: !!error,
          helpertext: error ? error.message : null,
        } as Partial<TextFieldProps>)
      }
    />
  );
};

export default ControlledInput;
